import { Component } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import { Router } from '@angular/router';
import { Paths } from '@shared/enums/paths.enums';
import { Spinkit } from 'ng-http-loader';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/messaging';
import 'firebase/functions';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public spinkit = Spinkit;
  title = 'app';
  isLogged = false;

  constructor(private router: Router, private authService: AuthService) {
    firebase.initializeApp(environment.firebase);
    this.authService.isLoggedIn.subscribe(isLogged => {
      this.isLogged = isLogged;

      if (!isLogged) {
        this.router.navigate([Paths.login]);
        return;
      }
    });
  }
}
